import defaultTheme from './default';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...defaultTheme,
  palette: {
    primary: ['#f00'],
    secondary: ['#0f0'],
  },
};
